import {
  Dialog, DialogTitle, DialogContent, TextField, InputAdornment,
  IconButton, Stack, Typography, Button, Box
} from "@mui/material";
import { Share2, X, Copy, Mail, CheckCircle } from "react-feather";

export default function ShareDialog({
  open,
  onClose,
  link,
  linkCopied,
  onCopyLink,
  onShareEmail,
  onShareWhatsApp,
  theme,
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth
      PaperProps={{ sx: { borderRadius: 3, p: 1 } }}
    >
      <DialogTitle>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Stack direction="row" alignItems="center" spacing={1.5}>
            <Share2 size={20} />
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
              Condividi Analisi Rischio
            </Typography>
          </Stack>
          <IconButton onClick={onClose} size="small" sx={{ color: theme.palette.text.secondary }}>
            <X size={20} />
          </IconButton>
        </Stack>
      </DialogTitle>

      <DialogContent>
        <Stack spacing={3}>
          <Typography variant="body2" color="text.secondary">
            Copia il link sicuro per condividere una vista web del report con clienti o colleghi.
          </Typography>

          <Box>
            <Typography variant="caption" color="text.secondary" sx={{ mb: 1, display: "block", fontWeight: 600 }}>
              Link di condivisione (valido 30 giorni)
            </Typography>
            <TextField
              fullWidth
              value={link}
              size="small"
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={onCopyLink} edge="end"
                      sx={{ color: linkCopied ? "success.main" : theme.palette.text.secondary }}
                    >
                      {linkCopied ? <CheckCircle size={18} /> : <Copy size={18} />}
                    </IconButton>
                  </InputAdornment>
                ),
                sx: { fontSize: 14, fontFamily: "monospace", borderRadius: 2 },
              }}
            />
          </Box>

          <Box>
            <Typography variant="caption" color="text.secondary" sx={{ mb: 1.5, display: "block", fontWeight: 600 }}>
              Oppure condividi direttamente tramite:
            </Typography>

            <Stack direction="row" spacing={1.5}>
              <Button variant="outlined" startIcon={<Mail size={16} />} onClick={onShareEmail} fullWidth
                sx={{ textTransform: "none", fontWeight: 600, borderRadius: 2, py: 1 }}
              >
                Email
              </Button>

              <Button variant="outlined" onClick={onShareWhatsApp} fullWidth
                sx={{ textTransform: "none", fontWeight: 600, borderRadius: 2, py: 1 }}
              >
                WhatsApp
              </Button>
            </Stack>
          </Box>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}